
// returns amount with two decimals in number format: 4,500.9 or 500 or 250.1 or 0
// Note: Javascript truncates last/ending zeros after decimals : 4,500.90 to 4,500.9 or 500.00 to 500 or 250.10 to 25.1 or 0

const TwoDecimalAmount = (e) => {
    let value = e;
    if (value) {
        value = Math.trunc(value * 100) / 100;
    } else {
        value = 0;
    }
    return value;
};

export default TwoDecimalAmount;